module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "EPI"
  }, [_vm._v("Now that my ladder’s gone,")]), _vm._v(" "), _c('p', {
    staticClass: "EPI"
  }, [_vm._v("I must lie down where all the ladders start,")]), _vm._v(" "), _c('p', {
    staticClass: "EPI"
  }, [_vm._v("In the foul rag-and-bone shop of the heart.")]), _vm._v(" "), _c('p', {
    staticClass: "EPS"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("—W. B. YEATS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0825b0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0